import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/puushdot-pool";

export const puushdotPoolService = {
  async list(filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(path + "?" + searchParams.toString());
  },

  async view(id) {
    return await axios.get(path + "/" + id);
  },

  async listActivity(id, filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(
      "/activity-puush-pool/paginate/" + id + "?" + searchParams.toString()
    );
  },
};
